import { Card, CardHeader, Grid, Typography, CardContent, Divider, Checkbox } from '@material-ui/core';
import React from 'react';
import classes from '../../../pages/createOrder/index.module.scss'
import Icon from '@mdi/react';
import { mdiAlertOctagonOutline } from '@mdi/js';

function OrderInfo(props: any) {
    const {
        form,
        children,
        cod,
        setCod,
        deliveryLocationType,
        setDeliveryLocationType,
        fulfillmentService,
        setFulfillmentService,
        notifType
    } = props
    const {
        getValues,
    } = form

    return (
        <Card className={classes.card}>
            <CardContent className={classes.cardContentOrder}>
                <Grid container alignItems="stretch" justifyContent='space-between' spacing={2}>
                    {children}
                </Grid>
                <Grid container spacing={1}>
                    <Grid
                        item
                        xs={12}
                        sm={3}
                        md={2}
                        lg={2}
                        alignItems="flex-start"
                    >
                        <div className={classes.item}>
                            <span className={classes.label}>
                                <Checkbox
                                    checked={fulfillmentService}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            setCod(false)
                                        }
                                        setFulfillmentService(e.target.checked);
                                    }}
                                    color="primary"
                                    inputProps={{
                                        'aria-label': 'secondary checkbox',
                                    }}
                                    data-cy="fulfillmentServiceCheckBox"
                                />
                            </span>

                            <div
                                style={{
                                    width: '100%',
                                    marginTop: '8px',
                                }}
                            >
                                <span>خدمات مرکز پردازش دیجی کالا</span>
                            </div>
                        </div>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={3}
                        md={2}
                        lg={2}
                        alignItems="flex-start"
                    >
                        <div className={classes.item}>
                            <span className={classes.label}>
                                <Checkbox
                                    checked={deliveryLocationType}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            setCod(false)
                                        }
                                        setDeliveryLocationType(e.target.checked);
                                    }}
                                    color="primary"
                                    inputProps={{
                                        'aria-label': 'secondary checkbox',
                                    }}
                                    data-cy="fulfillmentServiceCheckBox"
                                />
                            </span>

                            <div
                                style={{
                                    width: '100%',
                                    marginTop: '8px',
                                }}
                            >
                                <span>تحویل درب انبار </span>
                            </div>
                        </div>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={2}
                        alignItems="flex-start"
                    >
                        <div className={classes.item}>
                            <span className={classes.label}>
                                <Checkbox
                                    checked={cod}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            setFulfillmentService(false);
                                            setDeliveryLocationType(false);
                                        }
                                        setCod(e.target.checked);
                                    }}
                                    disabled={getValues("deliveryType") === "VIP"}
                                    color="primary"
                                    inputProps={{
                                        'aria-label': 'secondary checkbox',
                                    }}
                                />
                            </span>

                            <div
                                style={{
                                    width: '100%',
                                    marginTop: '8px',
                                }}
                            >
                                <span>پرداخت در محل (COD)</span>
                            </div>
                        </div>
                    </Grid>
                    {/* {notifType == "COURIER" && <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Typography style={{ marginTop: "20px", border: "1px solid #dfa02e", padding: "0 12px", borderRadius: "7px", fontSize: "15px" }}>
                            محدوده تحت پوشش سرویس عادی شامل <span style={{ fontWeight: "bold" }}>مناطق 22 گانه تهران به جز شهرک های قصرفیروزه، شهید باقری، آتی شهر و ضلع شمالی اتوبان بابایی بعد از جاده لشگرک</span> می باشد. جهت بهبود فرآیند ارسال به این مناطق لطفا از سرویس پست استفاده نمایید
                        </Typography>
                    </Grid>} */}
                    {notifType == "deliveryLocation" && <Grid item md={12} sm={12}>
                        <div className='notif' style={{marginTop: "8px"}}>
                        <Icon
                            path={mdiAlertOctagonOutline}
                            size={.8}
                        />
                        <Typography style={{marginRight: "10px", fontSize: "14px"}}>
                            امکان تحویل سفارش درب انبار تا ساعت 17 شنبه تا چهارشنبه و 12 ظهر برای پنج شنبه می باشد
                        </Typography>
                        </div>
                    </Grid>}
                    {/* KEEP the lines below maybe products change their mind */}
                    {/* {fulfillmentService && (
                    <Grid
                        item
                        xs={3}
                        sm={3}
                        md={3}
                        lg={3}
                        alignItems="flex-start"
                    >
                        <div className={classes.item}>
                            <div
                                style={{ width: '100%', marginTop: '20px' }}
                                data-cy="fulfillmentLine"
                            >
                                <FormControl style={{ width: '100%' }}>
                                    <Autocomplete
                                        disableClearable
                                        getOptionSelected={(option, value) =>
                                            option.name === value?.name
                                        }
                                        getOptionLabel={option => option.name}
                                        options={fulfillmentLines}
                                        value={fulfillmentLine}
                                        loading={fulfillmentLineLoading}
                                        onChange={(event: any, newValue: any) => {
                                            setFulfillmentLine(newValue);
                                        }}
                                        renderInput={params => (
                                            <TextField
                                                type="search"
                                                variant="outlined"
                                                {...params}
                                                label="مرکز پردازش"
                                                inputRef={register({
                                                    required: fulfillmentService,
                                                })}
                                                name="fulfillmentLine"
                                                id="fulfillmentLine"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <React.Fragment>
                                                            {fulfillmentLineLoading ? (
                                                                <CircularProgress
                                                                    color="inherit"
                                                                    size={20}
                                                                />
                                                            ) : null}
                                                            {params.InputProps.endAdornment}
                                                        </React.Fragment>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                </FormControl>
                                <FormHelperText error focused>
                                    {!fulfillmentLine &&
                                        fulfillmentService &&
                                        'مرکز پردازش الزامی میباشد'}
                                </FormHelperText>
                            </div>
                        </div>
                    </Grid>
                )} */}
                </Grid>
            </CardContent>
        </Card>
    )
}

export default OrderInfo;